module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/chat-bubble-question-46ad70ebca70bb64daa43305fceb9e56.svg";